"use strict";
exports.__esModule = true;
exports.validateJSONPointer = void 0;
function validateJSONPointer(value) {
    if (value !== '' && !value.startsWith('/')) {
        throw new Error('Invalid JSON pointer');
    }
}
exports.validateJSONPointer = validateJSONPointer;
